import { useSelector } from 'react-redux';

export const useCurrentVerticalData = () => {
    const {
        pamGameVerticalID,
        currentVerticalId,
        verticalsById,
    } = useSelector(state => state.app);

    const currentVertical = verticalsById?.[currentVerticalId];
    const currentVerticalType = currentVertical?.type;

    return {
        pamGameVerticalID,
        currentVerticalType,
    };
};
